import { Icon } from '@fasstech/middle-design-system';

export const CompanyInformations = ({ company, onEdit }) => {
  return (
    <div className="relative border p-4 flex flex-col min-w-3/8 w-fit rounded">
      {onEdit && (
        <Icon
          name={'circlePen'}
          size={30}
          wrapperClassName={'absolute top-3 right-3 cursor-pointer'}
          onClick={onEdit}
          data-testid="BENEFICIARY_CARD_EDIT"
        />
      )}
      <div className="flex flex-col items-center w-full p-2">
        <Icon
          name={'circleCompany'}
          fillCassName="fill-primary"
          size="48"
        ></Icon>
        <h5 className="font-bold">Entreprise</h5>
      </div>
      <div className="flex w-full gap-2">
        <div className="w-1/2 flex gap-2">
          <span className="font-semibold">Nom</span> <span>{company.name}</span>
        </div>
        <div className="w-1/2 flex gap-2">
          <span className="font-semibold">SIRET</span>{' '}
          <span> {company.siret}</span>
        </div>
      </div>

      <div className="w-full flex gap-2">
        <span className="font-semibold">CCN</span>
        <span>{company.ccn}</span>
      </div>
    </div>
  );
};
